import React, { lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@api/query-client.ts";
import {
  GeniusRegistrationProvider,
  GeniusRegistrationModal,
  GeniusBrochureModal
} from "../registration";
import { GENIUS_ROUTES } from "./geniusRouteConstants";
import { RecaptchaProvider } from "../../hooks/useRecaptcha";
import { GeniusContentProvider } from "../content";

const GeniusHome = lazy(() => import("@pages/Home"));
const GeniusRegisterSchool = lazy(() => import("@pages/RegisterSchool"));
const GeniusSchoolLogin = lazy(() => import("@pages/SchoolLogin"));
const GeniusMathOlympiad = lazy(() => import("@pages/MathOlympiad"));
const GeniusHotsOlympiad = lazy(() => import("@pages/HotsOlympiad"));
const GeniusScoreOlympiad = lazy(() => import("@pages/ScoreOlympiad"));
const GeniusChampions = lazy(() => import("@pages/Champions"));
const GeniusAbout = lazy(() => import("@pages/About"));
const GeniusNotFound = lazy(() => import("@pages/NotFound"));

const GeniusLoading = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "40vh" }}>
    <div className="spinner-border text-light" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

export const GeniusRoutes = () => (
  <QueryClientProvider client={queryClient}>
    <RecaptchaProvider>
      <GeniusContentProvider>
      <GeniusRegistrationProvider>
        <Suspense fallback={<GeniusLoading />}>
          <Switch>
            <Route exact path={GENIUS_ROUTES.HOME} component={GeniusHome} />
            <Route exact path={GENIUS_ROUTES.SCHOOL_REGISTER} component={GeniusRegisterSchool} />
            <Route exact path={GENIUS_ROUTES.SCHOOL_LOGIN} component={GeniusSchoolLogin} />
            <Route exact path={GENIUS_ROUTES.OLYMPIAD_MATH} component={GeniusMathOlympiad} />
            <Route exact path={GENIUS_ROUTES.OLYMPIAD_SCORE} component={GeniusScoreOlympiad} />
            <Route exact path={GENIUS_ROUTES.OLYMPIAD_HOTS} component={GeniusHotsOlympiad} />
            <Route exact path={GENIUS_ROUTES.CHAMPIONS} component={GeniusChampions} />
            <Route exact path={GENIUS_ROUTES.OLYMPIAD} component={GeniusNotFound} />
            <Route exact path={GENIUS_ROUTES.TESTIMONIALS} component={GeniusNotFound} />
            <Route exact path={GENIUS_ROUTES.HOW_IT_WORKS} component={GeniusNotFound} />
            <Route exact path={GENIUS_ROUTES.ABOUT} component={GeniusAbout} />
            <Route path={GENIUS_ROUTES.NOT_FOUND} component={GeniusNotFound} />
          </Switch>
        </Suspense>
        <GeniusRegistrationModal />
        <GeniusBrochureModal />
      </GeniusRegistrationProvider>
      </GeniusContentProvider>
    </RecaptchaProvider>
  </QueryClientProvider>
);
